// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { TeamMemberRoleFragmentDoc, TeamMemberFragmentDoc } from '../../projects/settings/TeamMembersTab.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentTeamMembersQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentTeamMembersQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, name: string, teamMembers: Array<{ __typename?: 'DevelopmentTeamMember', id: string, internalUser: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string, user: { __typename?: 'User', id: string, isActive: boolean } }, projectRole: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } }> }, projectRoleDetails: Array<{ __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }> };

export type UpdateDevelopmentProjectRoleMutationVariables = Types.Exact<{
  input: Types.SaveDevelopmentTeamMemberInput;
}>;


export type UpdateDevelopmentProjectRoleMutation = { __typename?: 'Mutation', saveDevelopmentTeamMember: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const DevelopmentTeamMembersDocument = gql`
    query DevelopmentTeamMembers($developmentId: ID!) {
  development(id: $developmentId) {
    ...Named
    teamMembers {
      id
      internalUser {
        ...TeamMember
        user {
          id
          isActive
        }
      }
      projectRole {
        ...TeamMemberRole
      }
    }
  }
  projectRoleDetails {
    ...TeamMemberRole
  }
  internalUsers {
    ...TeamMember
  }
}
    ${NamedFragmentDoc}
${TeamMemberFragmentDoc}
${TeamMemberRoleFragmentDoc}`;

/**
 * __useDevelopmentTeamMembersQuery__
 *
 * To run a query within a React component, call `useDevelopmentTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentTeamMembersQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentTeamMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables> & ({ variables: DevelopmentTeamMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>(DevelopmentTeamMembersDocument, options);
      }
export function useDevelopmentTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>(DevelopmentTeamMembersDocument, options);
        }
// @ts-ignore
export function useDevelopmentTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>;
export function useDevelopmentTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTeamMembersQuery | undefined, DevelopmentTeamMembersQueryVariables>;
export function useDevelopmentTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>(DevelopmentTeamMembersDocument, options);
        }
export type DevelopmentTeamMembersQueryHookResult = ReturnType<typeof useDevelopmentTeamMembersQuery>;
export type DevelopmentTeamMembersLazyQueryHookResult = ReturnType<typeof useDevelopmentTeamMembersLazyQuery>;
export type DevelopmentTeamMembersSuspenseQueryHookResult = ReturnType<typeof useDevelopmentTeamMembersSuspenseQuery>;
export type DevelopmentTeamMembersQueryResult = Apollo.QueryResult<DevelopmentTeamMembersQuery, DevelopmentTeamMembersQueryVariables>;
export const UpdateDevelopmentProjectRoleDocument = gql`
    mutation UpdateDevelopmentProjectRole($input: SaveDevelopmentTeamMemberInput!) {
  saveDevelopmentTeamMember(input: $input) {
    emptyResult
  }
}
    `;
export type UpdateDevelopmentProjectRoleMutationFn = Apollo.MutationFunction<UpdateDevelopmentProjectRoleMutation, UpdateDevelopmentProjectRoleMutationVariables>;

/**
 * __useUpdateDevelopmentProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateDevelopmentProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevelopmentProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevelopmentProjectRoleMutation, { data, loading, error }] = useUpdateDevelopmentProjectRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDevelopmentProjectRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDevelopmentProjectRoleMutation, UpdateDevelopmentProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDevelopmentProjectRoleMutation, UpdateDevelopmentProjectRoleMutationVariables>(UpdateDevelopmentProjectRoleDocument, options);
      }
export type UpdateDevelopmentProjectRoleMutationHookResult = ReturnType<typeof useUpdateDevelopmentProjectRoleMutation>;
export type UpdateDevelopmentProjectRoleMutationResult = Apollo.MutationResult<UpdateDevelopmentProjectRoleMutation>;
export type UpdateDevelopmentProjectRoleMutationOptions = Apollo.BaseMutationOptions<UpdateDevelopmentProjectRoleMutation, UpdateDevelopmentProjectRoleMutationVariables>;